import { useQuery } from '@apollo/client';
import { useEffect } from 'react';

import { GetUserIdentityDocument } from 'src/generated/graphql';
import { useAuth } from 'src/hooks/auth';
import { setGtagUserId } from 'src/utils/analytics/gtm';

export const GoogleAnalyticsUserSync = () => {
  const { authLoaded, getAuthToken } = useAuth();
  const isLoggedIn = authLoaded && Boolean(getAuthToken());

  const getUserIdentityResult = useQuery(GetUserIdentityDocument, {
    skip: !isLoggedIn,
  });

  useEffect(() => {
    if (!authLoaded) return;

    if (!isLoggedIn) {
      setGtagUserId(null);
      return;
    }

    if (
      !getUserIdentityResult.loading &&
      getUserIdentityResult.data?.user?.userId
    ) {
      setGtagUserId(getUserIdentityResult.data.user.userId);
    }
  }, [
    authLoaded,
    isLoggedIn,
    getUserIdentityResult.loading,
    getUserIdentityResult.data?.user?.userId,
  ]);

  return null;
};
